import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from 'react'
import { appThemeNames, applyAppTheme, resolveTheme, type AppTheme } from '../theme/theme'
export { themeLabels, type AppTheme } from '../theme/theme'
export const appThemes = appThemeNames
const storageKey = 'sbcms_theme'
interface ThemeContextValue {
  theme: AppTheme
  setTheme: (theme: AppTheme) => void
  themes: typeof appThemeNames
  availableThemes: typeof appThemeNames
}
const ThemeContext = createContext<ThemeContextValue | null>(null)
function storedTheme(): AppTheme {
  try { return resolveTheme(localStorage.getItem(storageKey)) }
  catch { return 'workbench' }
}
export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState<AppTheme>(storedTheme)
  useEffect(() => {
    applyAppTheme(document.documentElement, theme)
    try { localStorage.setItem(storageKey, theme) }
    catch { /* The selected theme still works when browser storage is unavailable. */ }
  }, [theme])
  const value = useMemo(() => ({ theme, setTheme, themes: appThemeNames, availableThemes: appThemeNames }), [theme])
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}
export function useTheme(): ThemeContextValue {
  const context = useContext(ThemeContext)
  if (!context) throw new Error('useTheme must be used within ThemeProvider')
  return context
}
export default ThemeProvider
